import { render } from "./customerfeedback.vue?vue&type=template&id=13bf91ea"
import script from "./customerfeedback.vue?vue&type=script&lang=js"
export * from "./customerfeedback.vue?vue&type=script&lang=js"

import "./customerfeedback.vue?vue&type=style&index=0&id=13bf91ea&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__